import cn from 'classnames';
import { useQueryPage } from 'hooks/routes';
import {
  ToBeginIcon_16,
  ToEndIcon_16,
  ToNextIcon_16,
  ToPreviousIcon_16,
} from 'assets/icons';
import Dropdown from 'components/Dropdown';
import styles from './TableFooter.module.css';

type FooterProps = {
  pages: number;
  totalRows: number;
  availableRowsPerPage?: number[];
};

const TableFooter = ({
  pages,
  totalRows,
  availableRowsPerPage = [10, 25, 50, 100],
}: FooterProps) => {
  const { page, size: rowsPerPage, setPage, setSize } = useQueryPage();

  const isFisrtPage = page === 1;
  const isLastPage = page === pages;

  const toNextPage = () => {
    if (page < pages) setPage(page + 1);
  };
  const toPreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };
  const toFirstPage = () => {
    setPage(1);
  };
  const toLastPage = () => {
    setPage(pages);
  };

  const firstRow = (page - 1) * rowsPerPage + 1;
  const lastRow = page === pages ? totalRows : firstRow + rowsPerPage - 1;

  const prevPageIconStyle = isFisrtPage ? styles.icon_disable : styles.icon_active;
  const nextPageIconStyle = isLastPage ? styles.icon_disable : styles.icon_active;

  return (
    <tfoot>
      <tr className={styles.footer}>
        <td>
          <p className={styles.label}>{'Rows per page'}</p>
        </td>
        <td className={styles.dropdown}>
          <Dropdown
            options={availableRowsPerPage}
            selectedOption={rowsPerPage}
            onSelect={setSize}
            size={'small'}
          />
        </td>
        <td>
          <p className={styles.label}>{`${firstRow} - ${lastRow} of ${totalRows}`}</p>
        </td>
        <td className={styles.icons}>
          <ToBeginIcon_16
            className={cn(styles.icon, prevPageIconStyle)}
            onClick={toFirstPage}
          />
          <ToPreviousIcon_16
            className={cn(styles.icon, prevPageIconStyle)}
            onClick={toPreviousPage}
          />
          <ToNextIcon_16
            className={cn(styles.icon, nextPageIconStyle)}
            onClick={toNextPage}
          />
          <ToEndIcon_16
            className={cn(styles.icon, nextPageIconStyle)}
            onClick={toLastPage}
          />
        </td>
      </tr>
    </tfoot>
  );
};

export default TableFooter;
